import { render, staticRenderFns } from "./UpdateAccountInfoStep.vue?vue&type=template&id=753b1017&"
import script from "./UpdateAccountInfoStep.vue?vue&type=script&lang=js&"
export * from "./UpdateAccountInfoStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports